module.exports = __webpack_public_path__ + "img/colegio_san_jose_apostolico.787a32df.png";